module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><circle cx=\"10\" cy=\"6\" r=\"5\" data-name=\"Ellipse 3\"></circle><path d=\"M10.001 13c-2 0-5.417.214-7 3-.6 1.22-.606 3 1 3h12c1.606 0 1.595-1.78 1-3-1.583-2.786-5-3-7-3z\" data-name=\"Path 8\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-audiences.svg
// module id = 247
// module chunks = 1